import { render, staticRenderFns } from "./AppResourceDropdown.vue?vue&type=template&id=f7f4345c"
import script from "./AppResourceDropdown.vue?vue&type=script&lang=js"
export * from "./AppResourceDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports